export default {
  blank: () => import("/app/layouts/blank.vue"),
  catalog: () => import("/app/layouts/catalog.vue"),
  "customer-office": () => import("/app/layouts/customer-office.vue"),
  default: () => import("/app/layouts/default.vue"),
  "master-office": () => import("/app/layouts/master-office.vue")
}